
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M58.998 34.684v-6.961l15.26 13.413-15.26 13.529v-6.962H53.14s-7.413-.464-8.328 6.196a8.984 8.984 0 0 0 0 1.392v10.744c.08 2.13-1.164 4.081-3.11 4.882a4.94 4.94 0 0 1-5.584-1.308l-.229-.255a5.1 5.1 0 0 1-1.235-3.319V46.287s-.206-6.288 4.393-9.166a8.608 8.608 0 0 1 3.111-1.23 13.553 13.553 0 0 1 2.494-.232"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53.465,
  cy: 35.644,
  r: 1.98,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M12.442 37.834 38.43 11.845c6.528-6.528 17.112-6.528 23.64 0l25.99 25.989c6.528 6.528 6.528 17.112 0 23.64L62.07 87.462c-6.528 6.528-17.112 6.528-23.64 0L12.442 61.474c-6.528-6.528-6.528-17.112 0-23.64z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M58.998 34.684v-6.961l15.26 13.413-15.26 13.529v-6.962H53.14s-7.413-.464-8.328 6.196c-.036.463-.036.929 0 1.392v10.744c.08 2.13-1.164 4.081-3.11 4.882-1.948.8-4.18.277-5.584-1.308l-.229-.255c-.793-.919-1.232-2.097-1.235-3.319V46.287s-.206-6.288 4.393-9.166c.948-.61 2.005-1.028 3.111-1.23.823-.154 1.657-.232 2.494-.232\"/>\r\n            <circle cx=\"53.465\" cy=\"35.644\" r=\"1.98\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n            <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M12.442 37.834L38.43 11.845c6.528-6.528 17.112-6.528 23.64 0L88.06 37.834c6.528 6.528 6.528 17.112 0 23.64L62.07 87.462c-6.528 6.528-17.112 6.528-23.64 0L12.442 61.474c-6.528-6.528-6.528-17.112 0-23.64z\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-error.3a96aa0e79b048fbfaf927ad6dabb592.svg"),
        {
          React: SvgIconsError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      